// @format
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import DownloadBtnVisibleContext from 'modules/context/DownloadBtnVisibleContext';

import background from './landingw.png';
import backgroundMobile from './landingw-mobile.png';
import detectCircle from './detectcircle.png';
import detectCircleMobile from './detectcircle-mobil.png';
import detectResult from './detect.png';
import detectResultMobile from './detect-mobile.png';
import DownloadButton from '../DownloadButton';
import MatchMedia from 'modules/components/MatchMedia';
import './IntroSection.css';

const IntroSection = ({ className }) => (
  <section className={classnames('IntroSection', className)}>
    <MatchMedia mediaQueries="(min-width: 1149px)">
      {isMatched => (
        <div className="IntroSection-bg">
          <img
            className="IntroSection-bg-wide"
            src={isMatched ? background : backgroundMobile}
            alt="background"
          />
          <img
            className="IntroSection-bg-circle"
            src={isMatched ? detectCircle : detectCircleMobile}
            alt="search circle"
          />
          <img
            className="IntroSection-bg-result"
            src={isMatched ? detectResult : detectResultMobile}
            alt="search result"
          />
          <div className="IntroSection-bg-overlay" />
        </div>
      )}
    </MatchMedia>
    <div className="IntroSection-content">
      <p className="IntroSection-desc">
        <span>See someone you are insterested?</span>
        <span>Snap a photo and</span>
        <span>We will do the rest</span>
      </p>
    </div>
    <DownloadBtnVisibleContext.Consumer>
      {({ setVisible }) => (
        <VisibilitySensor onChange={setVisible}>
          <DownloadButton className="IntroSection-download" />
        </VisibilitySensor>
      )}
    </DownloadBtnVisibleContext.Consumer>
  </section>
);

IntroSection.propType = {
  className: PropTypes.string,
};

export default IntroSection;



// WEBPACK FOOTER //
// ./src/modules/components/IntroSection/IntroSection.js